'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var SyntheticEventTarget = (0, _immutable.Record)({
  value: null
}, 'SyntheticEventTarget');

var SyntheticEventRoot = (0, _immutable.Record)({
  // mimics the target property of a React/DOM event
  target: SyntheticEventTarget(),
  // same as target, for our purposes (#1270)
  currentTarget: SyntheticEventTarget(),
  // the original React/DOM event that trigger this one
  source: null,
  // methods that map to the original event, if available
  preventDefault: function preventDefault() {
    if (this.source) {
      this.source.preventDefault();
    }
  },
  stopPropagation: function stopPropagation() {
    if (this.source) {
      this.source.stopPropagation();
    }
  }
}, 'SyntheticEvent');

function SyntheticEvent(value, evt) {
  var target = SyntheticEventTarget({
    value: value
  });
  return SyntheticEventRoot({
    target: target,
    currentTarget: target,
    source: evt
  });
}

SyntheticEvent.constructor = SyntheticEventRoot;

exports.default = SyntheticEvent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/core/SyntheticEvent.js
// module id = 61
// module chunks = 0 1